import axios from 'axios';

let base_url;

if(typeof window !== "undefined" && window.location.host === 'test-vendor-dashboard.fanni.site') {
    base_url = 'https://fanni-testing-1603da5414b1.herokuapp.com';
} else {
    base_url = process.env.REACT_APP_API_URL;
}

 const apiClientFiles = axios.create({
    baseURL: base_url,
    headers: {
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'x-User-Agent': 'dashboard',
        'Accept-Language': 'ar',
        'content-disposition': 'attachment; filename=template.xlsx'
    }
  });

  apiClientFiles.interceptors.request.use(
    (config) => {
      if(typeof window !== "undefined") {
        const token = window?.localStorage?.getItem('token') || false;
        if (token) {
          config.headers["Authorization"] = `Bearer ${token}`; 
        }
        const currentLang = 
          window.localStorage.getItem('i18nextLng') ||
          document.documentElement.lang || 
          (document.documentElement.dir === 'rtl' ? 'ar' : 'en');
        
        config.headers['Accept-Language'] = currentLang;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );


  apiClientFiles.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {

        
        const excludedUrls = ['/b-owners/register', '/b-users/one-time-password-login', '/b-users/login'];
    
        if (!excludedUrls.includes(err.config.url) && err.response) {
           if (err?.response?.status === 401) {
            if(err?.response?.data?.category === "UNAUTHORIZED") {
              localStorage.removeItem('user');
              localStorage.removeItem('token');
              const pathLang = window.location.pathname.split('/')[1] || 'ar';
              window.location.href = `/${pathLang}/login`;
            }
                // toast('يجب عليك تسجيل الدخول مرة اخرى', { hideProgressBar: true, autoClose: 2000, type: 'error' })
                // deleteCookie('token');
                // localStorage.removeItem('user');
                // localStorage.removeItem('token');
                // window.location.href = `/ar/login`; 
                return;
            } else {
                if(err?.response?.data?.message) {
                    // toast(err.response.data.message, { hideProgressBar: true, autoClose: 2000, type: 'error' });
                    // const errorsList = err?.response?.data?.errors;
                    // if(errorsList) {
                    //   Array.isArray(errorsList) 
                    //   ? errorsList.map(err=>{
                    //     err.message && toast(err.field+' '+err.message, { hideProgressBar: true, autoClose: 2000, type: 'error' });
                    //   })
                    //   : errorsList.message && toast(errorsList.message, { hideProgressBar: true, autoClose: 2000, type: 'error' });
                    // }
                } else {
                    // toast('حدث خطأ, برجاء المحاولة لاحقا', { hideProgressBar: true, autoClose: 2000, type: 'error' })
                }
            }
        }
  
      return Promise.reject(err);
    }
  );

  export default apiClientFiles;